<template>
	<SlideYUpTransition :duration="animationDuration">
		<b-modal
			class="modal fade"
			ref="app-modal"
			:size="size"
			:hide-header="hideHeader"
			:modal-class="[{ 'modal-mini': type === 'mini' }, ...modalClasses]"
			@mousedown.self="closeModal"
			tabindex="-1"
			role="dialog"
			centered
			:content-class="[
				gradient ? `bg-gradient-${gradient}` : '',
				...modalContentClasses,
			]"
			@close="closeModal"
			@hide="closeModal"
			:hide-footer="hideFooter"
			:header-class="headerClasses"
			:footer-class="footerClasses"
			:body-class="bodyClasses"
			:aria-hidden="!show"
		>
			<b-overlay :show="isLoading" rounded="sm" no-wrap />
			<template v-slot:modal-header>
				<slot name="header"></slot>
				<slot name="close-button">
					<button
						type="button"
						class="close"
						v-if="showClose"
						@click="closeModal"
						data-dismiss="modal"
						aria-label="Close"
					>
						<span :aria-hidden="!show">×</span>
					</button>
				</slot>
			</template>
			<slot>
				<ClassesTable
					:isLoading="isLoading"
					headerTitle="All Classes"
					:headerButtonData="{ title: 'Add Classes', isDisabled: true }"
					:isSelecting="true"
					:tableData="allClasses"
					:tableHeaders="classTitles"
					@headerButtonClicked="selectedClasses"
					@viewClicked="viewClicked"
				/>
			</slot>
			<template v-slot:modal-footer>
				<slot name="footer"></slot>
			</template>
		</b-modal>
	</SlideYUpTransition>
</template>
<script>
import { SlideYUpTransition } from 'vue2-transitions';
import ClassItemManager from '../../models/ClassItem/ClassItemManager';
import ClassesTable from '../../views/Components/ClassesViews/ClassesTable.vue';

export default {
	name: 'modal',
	components: {
		SlideYUpTransition,
		ClassesTable,
	},
	props: {
		show: {
			type: Boolean,
			default: false,
		},
		showClose: {
			type: Boolean,
			default: true,
		},
		type: {
			type: String,
			default: '',
			validator(value) {
				let acceptedValues = ['', 'notice', 'mini'];
				return acceptedValues.indexOf(value) !== -1;
			},
			description: 'Modal type (notice|mini|"") ',
		},
		modalClasses: {
			type: [Object, String],
			description: 'Modal dialog css classes',
			default: '',
		},
		size: {
			type: String,
			description: 'Modal size',
			default: 'lg',
			validator(value) {
				let acceptedValues = ['', 'sm', 'lg'];
				return acceptedValues.indexOf(value) !== -1;
			},
		},
		modalContentClasses: {
			type: [Object, String],
			description: 'Modal dialog content css classes',
			default: '',
		},
		gradient: {
			type: String,
			description: 'Modal gradient type (danger, primary etc)',
		},
		headerClasses: {
			type: [Object, String],
			description: 'Modal Header css classes',
		},
		bodyClasses: {
			type: [Object, String],
			description: 'Modal Body css classes',
		},
		footerClasses: {
			type: [Object, String],
			description: 'Modal Footer css classes',
		},
		hideHeader: {
			type: Boolean,
			default: true,
		},
		hideFooter: {
			type: Boolean,
			default: true,
		},
		animationDuration: {
			type: Number,
			default: 500,
			description: 'Modal transition duration',
		},
		exemptedClasses: {
			type: Array,
			description: 'Classes to not show in this list',
			default() {
				return [];
			},
		},
	},
	data() {
		return {
			isLoading: false,
			allClasses: [],
			classTitles: [
				{
					key: 'selected',
					label: '',
					tdClass: 'align-middle',
				},
				{
					key: 'classTitle',
					label: 'Title',
					sortable: true,
					tdClass: 'align-middle',
					sortByFormatted: (value, key, item) => {
						return item.classTitle;
					},
				},
				{
					key: 'classStart',
					label: 'Start Date',
					sortable: true,
					tdClass: 'align-middle',
					formatter: (value, key, item) => {
						return `${this.$helpers.formatDate(value.toDate(), 'MMMM dd, yyyy')}`;
					},
				},
				{
					key: 'isPrivate',
					label: 'Privacy',
					sortable: true,
					tdClass: 'align-middle',
					formatter: (value, key, item) => {
						return item.isPrivate != null ? item.isPrivate : false;
					},
				},
			],
		};
	},
	methods: {
		closeModal() {
			this.$emit('update:show', false);
			this.$emit('close');
		},
		selectedClasses(item) {
			this.$emit('selectedClasses', item);
		},
		viewClicked(item) {
			this.$emit('viewClicked', item);
		},
		getAllClasses() {
			this.isLoading = true;
			ClassItemManager.getAllClasses().then(() => {
				this.allClasses = ClassItemManager.allClasses.filter(
					(e) => !this.exemptedClasses.find((a) => a.classId == e.classId)
				);
				this.isLoading = false;
			});
		},
	},
	watch: {
		show(val) {
			if (val) {
				this.$refs['app-modal'].show();
			} else {
				this.$refs['app-modal'].hide();
			}
		},
	},
	mounted() {
		this.getAllClasses();
	},
};
</script>
